
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToWork = () => {
    const element = document.getElementById('work');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/40242111f1131ec1e2972adb7acdfc6c.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Ethan Levine
          </h1>
          <p className="text-2xl md:text-3xl mb-8 max-w-3xl mx-auto font-semibold">
            Marketing Strategist
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={scrollToWork} size="lg" className="bg-blue-600 hover:bg-blue-700 px-10">
              <i className="ri-eye-line mr-2"></i>
              See The Highlights
            </Button>
            <Button onClick={scrollToContact} variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 px-10">
              <i className="ri-mail-line mr-2"></i>
              Get In Touch
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
